export default __webpack_public_path__ + "static/photoelectric2-420faaeedb2a16788269ffa8953198a5.png";